"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = require("immutable");

var I = _interopRequireWildcard(_immutable);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _queryString = require("query-string");

var _queryString2 = _interopRequireDefault(_queryString);

require("./Pagination.scss");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PAGINATION_DOTS = "...";
var getPages = function getPages(current, last) {
  return I.Range(1, last + 1).map(function (p) {
    return p == 1 || p == last || p > current - 2 && p < current + 2 ? p : PAGINATION_DOTS;
  }).filter(function (element, index, arr) {
    return element != PAGINATION_DOTS || !arr.get(index + 1) || arr.get(index + 1) != PAGINATION_DOTS;
  }).toArray();
};

var Pagination = function Pagination(props, context) {
  var _context$location = context.location,
      pathname = _context$location.pathname,
      query = _context$location.query,
      history = context.history;
  var count = props.count,
      currentPage = props.currentPage,
      perPage = props.perPage;


  var needRender = count > perPage;
  var totalPages = Math.ceil(count / perPage);
  var prevPage = currentPage - 1;
  var prevContent = void 0;
  if (prevPage) {
    prevContent = _react2.default.createElement(
      "li",
      { className: "pagination-prev-page" },
      _react2.default.createElement(
        "a",
        {
          onClick: function onClick() {
            return history.push({
              pathname: pathname,
              search: "?" + _queryString2.default.stringify(_extends({}, query, {
                page: prevPage
              }))
            });
          } },
        "\xAB Prev"
      )
    );
  }

  var nextPage = currentPage + 1;
  var nextContent = void 0;
  if (nextPage <= totalPages) {
    nextContent = _react2.default.createElement(
      "li",
      { className: "pagination-next-page" },
      _react2.default.createElement(
        "a",
        {
          onClick: function onClick() {
            return history.push({
              pathname: pathname,
              search: "?" + _queryString2.default.stringify(_extends({}, query, {
                page: nextPage
              }))
            });
          } },
        "Next \xBB"
      )
    );
  }

  var content = getPages(currentPage, totalPages).map(function (idx, key) {
    if (idx === PAGINATION_DOTS) {
      return _react2.default.createElement(
        "li",
        { className: "pagination-dots text-muted", key: key },
        PAGINATION_DOTS
      );
    }

    var isActive = idx === currentPage;

    return _react2.default.createElement(
      "li",
      {
        className: (0, _classnames2.default)({
          "active": isActive
        }),
        key: key },
      _react2.default.createElement(
        "a",
        {
          onClick: function onClick() {
            return !isActive && history.push({
              pathname: pathname,
              search: "?" + _queryString2.default.stringify(_extends({}, query, {
                page: idx
              }))
            });
          } },
        idx
      )
    );
  });

  var allContent = needRender ? _react2.default.createElement(
    "ul",
    { className: "erg-components-Pagination pagination erg-pagination" },
    prevContent,
    content,
    nextContent
  ) : null;

  return allContent;
};

Pagination.contextTypes = {
  location: _propTypes2.default.object.isRequired,
  history: _propTypes2.default.object.isRequired
};

Pagination.propTypes = {
  count: _propTypes2.default.number.isRequired,
  currentPage: _propTypes2.default.number.isRequired,
  perPage: _propTypes2.default.number.isRequired
};

exports.default = Pagination;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/table/Pagination.js
 ** module id = 797
 ** module chunks = 0
 **/